import React, { useEffect} from "react";
import { Link } from "react-router-dom";
import { useAuthContext } from "../backend/UseAuth";
import { useSignup } from '../backend/Register'
import { getDoc, collection, doc, getFirestore } from "firebase/firestore";
import { useState } from "react";
export default function Tests2() {

    const db = getFirestore();
    const { user } = useAuthContext()
    const { logout } = useSignup()
    const handleSubmit = (e) => {
        logout()
    }
    const [Alldocs, setAlldocs] = useState([]);
    const [singleDoc, setSingledoc] = useState([]);

    useEffect(() => {

        getDoc(doc(db, "users", user.uid)).then(docSnap => {
            if (docSnap.exists()) {
                setSingledoc(docSnap.data());
            } else {
                console.log("No such document!");
            }
        })
    }, [])



    return (
        <React.Fragment>
            <div className="overlay"></div>

            <div className="main-body-wrapper d-flex">

                <div className="sidebar-wrapper bg--accent">
                    <div className="sidebar-inner">
                        <ul className="sidebar-menu">
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/contributions" className="sidebar-menu-link"><img src="assets/images/icon/menu1.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/tests" className="sidebar-menu-link"><img src="assets/images/icon/menu2.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/domain" className="sidebar-menu-link"> <img src="assets/images/icon/menu3.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/visualization" className="sidebar-menu-link"> <img src="assets/images/icon/menu4.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/lists" className="sidebar-menu-link"> <img src="assets/images/icon/menu5.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/profile" className="sidebar-menu-link"> <img src="assets/images/icon/menu6.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="main-content">
                    <div className="main-content-inner">

                        <div className="top-menu-wrapper bg-white">
                            <div className="top-menu-inner d-flex flex-wrap gap-2 justify-content-between">
                                <div className="d-sm-block">
                                    <div className="sidebar-toggler fs--20px d-md-none"><i className="fas fa-bars"></i></div>
                                </div>
                                <a href="contributions.html" className="logo"><img src="assets/images/logo.png" alt="logo" /></a>
                                <ul className="top-menu d-flex flex-wrap gap-3">
                                    <li className="top-menu-item">
                                        <a href="javascript:void(0)" className="top-menu-link"><i className="fas fa-bell"></i></a>
                                        <div className="dropdown-wrapper">
                                            <div className="dropdown-inner">
                                                <div className="dropdown-header">
                                                    <div className="d-flex flex-wrap justify-content-between pb-2">
                                                        <h6>Notifications</h6>
                                                        <span>Mark all as read</span>
                                                    </div>
                                                    <ul className="notification">
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="top-menu-item">
                                        <a href="javascript:void(0)" className="top-menu-link"><i className="fas fa-user"></i></a>
                                        <div className="dropdown-wrapper">
                                            <div className="dropdown-inner">
                                                <ul className="notification">
                                                    <li className="notification-item border-0">
                                                        <div className="d-flex gap-3">
                                                            <div className="notification-item__thumb">
                                                                <i className="fas fa-user"></i>
                                                            </div>
                                                            <div className="notification-item__content">
                                                            {
                                                                    singleDoc.firstname && <h6 className="notification-item__content-name">
                                                                        {singleDoc.firstname + " " + singleDoc.lastname}
                                                                    </h6>
                                                                }
                                                                <p>Admin</p>
                                                                {
                                                                    <Link to="/profile" className="mt-3 d-block fs--14px fw-semibold">Edit Profile
                                                                    </Link>
                                                                }
                                                                {
                                                                    <Link to="/" onClick={handleSubmit} className="mt-1 d-block fs--14px fw-semibold text--danger">  Log Out
                                                                    </Link>
                                                                }
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="main-content-inner-inner">
                            <div className="card custom--card">
                                <div className="card-header pb-0 d-flex flex-wrap gap-3 justify-content-between align-items-start">
                                    <div className="card-header__left">
                                        <h4 className="title"><a href="#0" onclick="history.back()" className="back-btn p-3 lh-1"><i className="fas fa-angle-left"></i></a> Filipino - Cebuano Test Questions</h4>
                                        <ul className="nav-tabs nav filter mt-2">
                                            <li className="nav-item"><a href="#all-tests" className="nav-link active" data-bs-toggle="tab">All Questions</a></li>
                                        </ul>
                                    </div>
                                    <button className="btn btn--success" data-bs-toggle="modal" data-bs-target="#addQuestionModal">Add Question</button>
                                </div>
                                <div className="card-body">
                                    <div className="d-flex flex-wrap justify-content-between gap-3 mb-4">
                                        <div className="search-wrapper">
                                            <form action="">
                                                <div className="form-group">
                                                    <input type="text" className="form-control form--control ps-5" />
                                                    <button className="btn fs--18px border-0 btn--icon" type="submit"><i className="fas fa-search"></i></button>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="d-flex flex-wrap gap-3">
                                            <select>
                                                <option value="">Filter by</option>
                                                <option value="">Upper to Low</option>
                                                <option value="">Lower to Upper</option>
                                            </select>
                                            <select>
                                                <option value="">Filter by</option>
                                                <option value="">Upper to Low</option>
                                                <option value="">Lower to Upper</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="tab-content">
                                        <div className="tab-pane show fade active" id="all-tests">
                                            <table className="table table--responsive--xl">
                                                <thead>
                                                    <tr>
                                                        <th>Item Number</th>
                                                        <th>Question</th>
                                                        <th>Option 1</th>
                                                        <th>Option 2</th>
                                                        <th>Option 3</th>
                                                        <th>Option 4</th>
                                                        <th>Author</th>
                                                        <th>Edit</th>
                                                        <th>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td data-label="Item Number">01</td>
                                                        <td data-label="Question">Lorem ipsum dolor sit amet?</td>
                                                        <td data-label="Option 1">Lorem ipsum (1)</td>
                                                        <td data-label="Option 2">Lorem ipsum (2)</td>
                                                        <td data-label="Option 3">Lorem ipsum (3)</td>
                                                        <td data-label="Option 4">Lorem ipsum (4)</td>
                                                        <td data-label="Author">Admin1</td>
                                                        <td data-label="Edit"><button className="btn btn--warning btn--icon"><i className="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button className="btn btn--danger btn--icon remove-item"><i className="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Item Number">01</td>
                                                        <td data-label="Question">Lorem ipsum dolor sit amet?</td>
                                                        <td data-label="Option 1">Lorem ipsum (1)</td>
                                                        <td data-label="Option 2">Lorem ipsum (2)</td>
                                                        <td data-label="Option 3">Lorem ipsum (3)</td>
                                                        <td data-label="Option 4">Lorem ipsum (4)</td>
                                                        <td data-label="Author">Admin1</td>
                                                        <td data-label="Edit"><button className="btn btn--warning btn--icon"><i className="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button className="btn btn--danger btn--icon remove-item"><i className="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Item Number">01</td>
                                                        <td data-label="Question">Lorem ipsum dolor sit amet?</td>
                                                        <td data-label="Option 1">Lorem ipsum (1)</td>
                                                        <td data-label="Option 2">Lorem ipsum (2)</td>
                                                        <td data-label="Option 3">Lorem ipsum (3)</td>
                                                        <td data-label="Option 4">Lorem ipsum (4)</td>
                                                        <td data-label="Author">Admin1</td>
                                                        <td data-label="Edit"><button className="btn btn--warning btn--icon"><i className="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button className="btn btn--danger btn--icon remove-item"><i className="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Item Number">01</td>
                                                        <td data-label="Question">Lorem ipsum dolor sit amet?</td>
                                                        <td data-label="Option 1">Lorem ipsum (1)</td>
                                                        <td data-label="Option 2">Lorem ipsum (2)</td>
                                                        <td data-label="Option 3">Lorem ipsum (3)</td>
                                                        <td data-label="Option 4">Lorem ipsum (4)</td>
                                                        <td data-label="Author">Admin1</td>
                                                        <td data-label="Edit"><button className="btn btn--warning btn--icon"><i className="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button className="btn btn--danger btn--icon remove-item"><i className="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Item Number">01</td>
                                                        <td data-label="Question">Lorem ipsum dolor sit amet?</td>
                                                        <td data-label="Option 1">Lorem ipsum (1)</td>
                                                        <td data-label="Option 2">Lorem ipsum (2)</td>
                                                        <td data-label="Option 3">Lorem ipsum (3)</td>
                                                        <td data-label="Option 4">Lorem ipsum (4)</td>
                                                        <td data-label="Author">Admin1</td>
                                                        <td data-label="Edit"><button className="btn btn--warning btn--icon"><i className="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button className="btn btn--danger btn--icon remove-item"><i className="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Item Number">01</td>
                                                        <td data-label="Question">Lorem ipsum dolor sit amet?</td>
                                                        <td data-label="Option 1">Lorem ipsum (1)</td>
                                                        <td data-label="Option 2">Lorem ipsum (2)</td>
                                                        <td data-label="Option 3">Lorem ipsum (3)</td>
                                                        <td data-label="Option 4">Lorem ipsum (4)</td>
                                                        <td data-label="Author">Admin1</td>
                                                        <td data-label="Edit"><button className="btn btn--warning btn--icon"><i className="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button className="btn btn--danger btn--icon remove-item"><i className="fas fa-trash"></i></button></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="addQuestionModal" tabindex="-1" aria-labelledby="addQuestionModal" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content border-0">
                        <div className="modal-body">
                            <form action="">
                                <h4 className="title mb-4 pb-lg-2">Add Test Question</h4>
                                <div className="row gy-3 gx-xl-5">
                                    <div className="col-12">
                                        <textarea name="" id="" cols="30" rows="10" className="form-control form--control" placeholder="Message"></textarea>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="row gy-3 gx-3 gx-xl-5">
                                            <div className="col-8">
                                                <input type="text" className="form-control form--control" placeholder="Option 1" />
                                            </div>
                                            <div className="col-4">
                                                <input type="text" className="form-control form--control" placeholder="Point(s)" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="row gy-3 gx-3 gx-xl-5">
                                            <div className="col-8">
                                                <input type="text" className="form-control form--control" placeholder="Option 1" />
                                            </div>
                                            <div className="col-4">
                                                <input type="text" className="form-control form--control" placeholder="Point(s)" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="row gy-3 gx-3 gx-xl-5">
                                            <div className="col-8">
                                                <input type="text" className="form-control form--control" placeholder="Option 1" />
                                            </div>
                                            <div className="col-4">
                                                <input type="text" className="form-control form--control" placeholder="Point(s)" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="row gy-3 gx-3 gx-xl-5">
                                            <div className="col-8">
                                                <input type="text" className="form-control form--control" placeholder="Option 1" />
                                            </div>
                                            <div className="col-4">
                                                <input type="text" className="form-control form--control" placeholder="Point(s)" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-wrap justify-content-between mt-4">
                                        <button type="button" className="btn btn--primary">Active</button>
                                        <button type="submit" className="btn btn--success">Add</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}